export const BANNER_TYPE = {
  banner: 0,
  largeBanner: 1,
  heading: 2,
  link: 3,
  staticImg: 4,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/statics.js